'use strict';

var withPrecision = require('../../common/internal/withPrecision');

function incrementNumber(current, amount, precision) {
  return withPrecision(current + amount, precision);
}

module.exports = incrementNumber;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/range/internal/incrementNumber.js
// module id = 858
// module chunks = 0